import { getRequest } from "../../globalhelper/helper";
import { CSVLink } from "react-csv";
import { useState, useEffect } from "react";
import moment from "moment";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
  AlertTitle,
  Box,
  Button,
  Typography,
  Grid,
TextField,
Autocomplete
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import {
  showLoader,
  hideLoader
} from "../../redux/Common/commonActions";
import NewDynamicTable from "../Edureka/NewDynamicTable";

const PaymentCycle = () => {

  const dispatch = useDispatch();

  const [tableData, setTableData] = useState([]);
  const [Companies, setCompanies] = useState([]);

    const [formData, setFormData] = useState({
    company: "",
    runDate: moment()
    });

    useEffect(() => {
        getRequest("api/edureka/getCompanyAssignedToUser")
            .then(({ res }) => {
            setCompanies(res.data || []);
            })
            .catch(console.error);
    }, []);

  const handleSubmit = () => {

    dispatch(showLoader());

    const runDate = formData.runDate
    ? moment(formData.runDate).format("YYYY-MM-DD")
    : "";

    getRequest(
    `api/edureka/getPaymentCycleReport?orgid=${formData.company?.orgid}&rundate=${runDate}`
    )
      .then(({ res }) => {
        setTableData(res.data || []);
      })
      .catch(console.error)
      .finally(() => dispatch(hideLoader()));
  };

  const handleChange = (name, value) => {
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

const handleReset = () => {
  setTableData([]);

  setFormData({
    company: "",
    runDate: moment()
  });
};

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography variant="h6">
            Payment Cycle Report
          </Typography>
        </AccordionSummary>

<AccordionDetails>
            <Grid container spacing={2} alignItems="center">

            <Grid item xs={12} md={4}>
                <Autocomplete
                size="small"
                value={formData.company}
                options={Companies}
                getOptionLabel={option => option?.orgname || ""}
                onChange={(e, value) =>
                    handleChange("company", value)
                }
                renderInput={(params) => (
                    <TextField
                    {...params}
                    label="Company"
                    />
                )}
                />
            </Grid>

            <Grid item xs={12} md={3}>
                <LocalizationProvider
                dateAdapter={AdapterMoment}
                >
                <DatePicker
                    label="Run Date"
                    value={formData.runDate}
                    onChange={(newValue) =>
                    handleChange("runDate", newValue)
                    }
                    renderInput={(params) => (
                    <TextField
                        {...params}
                        size="small"
                        fullWidth
                    />
                    )}
                />
                </LocalizationProvider>
            </Grid>

            <Grid item>
                <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={!formData.company}
                >
                Load Report
                </Button>

                <Button
                color="error"
                variant="contained"
                sx={{ ml: 1 }}
                onClick={handleReset}
                >
                Reset
                </Button>

                {tableData.length > 0 && (
                <Button
                    color="success"
                    variant="contained"
                    sx={{ ml: 1 }}
                >
                    <CSVLink
                    data={tableData}
                    filename="Payment_Cycle_Report.csv"
                    style={{
                        color: "white",
                        textDecoration: "none"
                    }}
                    >
                    Download
                    </CSVLink>
                </Button>
                )}
            </Grid>

            </Grid>
            </AccordionDetails>
      </Accordion>

      {tableData.length ? (
        <NewDynamicTable
          data={tableData}
        />
      ) : (
        <Box sx={{ mt: 2 }}>
          <Alert severity="warning">
            <AlertTitle>No Data Found</AlertTitle>
            There is no data to display.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default PaymentCycle;